<template>
  <div class="information-tab">
    <div class="row q-col-gutter-sm">
      <div class="col-md-6">
        <div class="row q-col-gutter-sm">
          <div class="col-12">
            <info :message="$t('Common.CompanyDetails.Text')"></info>
          </div>
          <div class="col-12">
            <q-input
              v-model="salesData.corporate_sales.company_name"
              class="required"
              hide-bottom-space
              dense
              outlined
              :label="$t('sales.salesOrder.corporateSales.companyName')"
              :error="validations.corporate_sales.company_name.$error"
              :error-message="$t('sales.salesOrder.corporateSales.companyName.errorLabel')"
              :disable="lockSalesOrder"
            />
          </div>
          <div class="col-12">
            <q-input
              v-model="salesData.corporate_sales.company_reg_number"
              class="required"
              hide-bottom-space
              dense
              outlined
              :label="$t('sales.salesOrder.corporateSales.company_reg_number')"
              :error="validations.corporate_sales.company_reg_number.$error"
              :error-message="$t('sales.salesOrder.corporateSales.company_reg_number.errorLabel')"
              :disable="lockSalesOrder"
            />
          </div>
          <div class="col-12">
            <q-input
              v-model="salesData.corporate_sales.company_email"
              class="required"
              hide-bottom-space
              dense
              outlined
              :label="$t('sales.salesOrder.corporateSales.company_email')"
              :error="validations.corporate_sales.company_email.$error"
              :error-message="$t('sales.salesOrder.corporateSales.company_email.errorLabel')"
              :disable="lockSalesOrder"
            />
          </div>
          <div class="col-12">
            <q-input
              v-model="salesData.corporate_sales.person_in_charge"
              class="required"
              hide-bottom-space
              dense
              outlined
              :label="$t('sales.salesOrder.corporateSales.personInCharge')"
              :error="validations.corporate_sales.person_in_charge.$error"
              :error-message="$t('sales.salesOrder.corporateSales.personInCharge.errorLabel')"
              :disable="lockSalesOrder"
            />
          </div>
          <div class="col-12">
            <div class="row q-col-gutter-sm">
              <div class="col-4">
                <q-select
                  v-model="salesData.corporate_sales.contact_country_code_id"
                  class="required"
                  :label="$t('Common.CountryCode.Text')"
                  :error="
                    validations.corporate_sales.contact_country_code_id.$error ||
                      validations.corporate_sales.contact_number.$error
                  "
                  hide-bottom-space
                  options-dense
                  dense
                  emit-value
                  map-options
                  outlined
                  clearable
                  :disable="lockSalesOrder"
                  :options="callCodeOptionsByCountry"
                />
              </div>
              <div class="col-8">
                <q-input
                  v-model="salesData.corporate_sales.contact_number"
                  class="required"
                  :label="$t('members.information.mobile1')"
                  :error="
                    validations.corporate_sales.contact_country_code_id.$error ||
                      validations.corporate_sales.contact_number.$error
                  "
                  hide-bottom-space
                  dense
                  outlined
                  :disable="lockSalesOrder || salesData.corporate_sales.contact_country_code_id === ''"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row q-col-gutter-sm">
          <div class="col-12">
            <info :message="$t('Common.CompanyAddress.Text')"></info>
          </div>
          <div class="col-12">
            <ShippingAddress
              v-for="(address, index) in getAddresses"
              ref="businessAddress"
              :key="`address-${index}`"
              :country-id="salesData.country_id"
              :address="address"
              :load-default-address="!lockSalesOrder"
              :option-filters="{ countries: [salesData.country_id] }"
              use-in-built-field-change
            ></ShippingAddress>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ShippingAddress } from 'src/application/global/components'
import { MasterDataTransformarMixin } from 'src/application/global/mixins/index'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'CooperateDetail',
  components: {
    ShippingAddress,
  },
  mixins: [MasterDataTransformarMixin],
  props: {
    salesData: {
      type: Object,
      required: true,
    },
    validations: {
      type: Object,
      required: true,
    },
    lockSalesOrder: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    ...mapGetters(['callCodeOptionsByCountry']),
    ...mapState({
      countriesOptions: state => state.globalCMP.countriesOptions.data,
      appSettings: state => state.globalCMP.appSettings,
    }),
    getAddresses() {
      return this.$helpers.getValue(this.salesData, 'corporate_sales.company_address', [])
    },
  },
}
</script>
